import { render, staticRenderFns } from "./gzzoc-congenital-cataract.vue?vue&type=template&id=56a7ea8f&scoped=true&lang=pug&"
import script from "./gzzoc-congenital-cataract.vue?vue&type=script&lang=js&"
export * from "./gzzoc-congenital-cataract.vue?vue&type=script&lang=js&"
import style0 from "./gzzoc-congenital-cataract.vue?vue&type=style&index=0&id=56a7ea8f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a7ea8f",
  null
  
)

export default component.exports